import EmailAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/common/embedded/email/email.entity";
import PhoneAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/common/embedded/phone/phone.entity";
import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatCommonModule } from "@angular/material/core";
import { MatDialog } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatTableModule } from "@angular/material/table";
import { AddBusinessPartnerEmailComponent } from "app/modules/components/business-partners/business-partner/business-partner-email-modal/business-partner-email.component";
import { DeleteConfirmationComponent } from "app/modules/components/business-partners/business-partner/delete-modal/delete-modal.component";
import { FormSectionComponent } from "app/shared/components/form-ui/form-section/form-section.component";

@Component({
  selector: "app-sales-office-email-section",
  templateUrl: "./sales-office-email-section.component.html",
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatSlideToggleModule,
    MatAutocompleteModule,
    MatCommonModule,
    AddBusinessPartnerEmailComponent,
    FormSectionComponent,
  ],
})
export class SalesOfficeEmailSectionComponent {
  @Input() emails: EmailAttributes[] = [];
  @Output() emailsChange = new EventEmitter<EmailAttributes>();
  @Output() emailDelete = new EventEmitter<EmailAttributes>();
  @Output() emailStatusChange = new EventEmitter<{
    email: EmailAttributes;
    newStatus: boolean;
  }>();

  displayedColumnsEmail: string[] = ["email", "statusId", "actions"];

  constructor(private dialog: MatDialog) {}

  openEmailModal(existingData?: EmailAttributes) {
    const dialogRef = this.dialog.open(AddBusinessPartnerEmailComponent, {
      width: "90vw",
      maxWidth: "450px",
      data: existingData,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result: EmailAttributes) => {
      if (!result) return;
      this.emailsChange.emit({ ...result, _id: existingData?._id });
    });
  }

  openDeleteEmail(email: EmailAttributes) {
    const dialogRef = this.dialog.open(DeleteConfirmationComponent, {
      data: email,
      panelClass: "delete-modal",
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((confirmed) => {
      if (confirmed) {
        this.emailDelete.emit(email);
      }
    });
  }
  onStatusToggle(checked: boolean, email: EmailAttributes) {
    this.emailStatusChange.emit({ email, newStatus: checked });
  }
}
